import { render, staticRenderFns } from "./App.vue?vue&type=template&id=fae9dc08"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./assets/css/main.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=fae9dc08&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports